(function () {
  class WinningsText extends PIXI.Container {
    constructor() {
      super();

      Reflex.registerEventHandler('ready', this.onReady.bind(this));
      Reflex.registerEventHandler('orientationChange', this.onOrientationChange.bind(this));
      messageBus.subscribe('spinner:SpinEvent', this.doSpin.bind(this));
    }

    onReady = function () {
      this._container = resourceManager.get(this.name + ':winningsTextContainer');

      // this._blackMask = resourceManager.get(this.name + ':winningsTextContainer:blackmask');

      this._glow = resourceManager.get(this.name + ':winningsTextContainer:textPanelContainer:glowRays');
      this._glowTween = gsap.to(this._glow, {
        rotation: '+=10',
        duration: 10,
        repeat: -1,
      });
      this._glow.visible = false;
      this._glowTween.pause(0);

      this._totalWinPanel = resourceManager.get(this.name + ':winningsTextContainer:textPanelContainer');
      this._totalWinBacker = resourceManager.get(this.name + ':winningsTextContainer:textPanelContainer:backerPanel');
      this._totalWinText = resourceManager.get(this.name + ':winningsTextContainer:textPanelContainer:winningsText');
      this._multiplierText = resourceManager.get(this.name + ':winningsTextContainer:multiplierText');
      this._winTextSparks = resourceManager.get(this.name + ':winningsTextContainer:winTextSparks');

      this._value = 0;

      this.show(false);

      this._textAnimTimeline = undefined;
      this._multiplierTimeline = undefined;
      this._animOut = undefined;
    };

    onOrientationChange() {
      if (this._multiplierTimeline !== undefined) {
        if (this._multiplierTimeline.progress() < 0.9) {
          this._multiplierTimeline.progress(9);
        }
      }

      // Update position if visible
      if (this._container && this._container.visible) {
        this.position = helpers.getSymbolPos(2, 1);
      }
    }

    displayWinline = function (value, reel, row, duration, megawildMulti, megawildOnReel3) {
      let self = this;
      const scaleInTime = 0.05;
      const scaleOutTime = 0.05;
      this.show(true);
      this.setText(value, true);
      this.position = helpers.getSymbolPos(reel, row);
      if (megawildOnReel3) {
        this.position.y -= 30;
      }
      this._totalWinPanel.visible = true;
      this._multiplierText.visible = false;
      this._totalWinBacker.visible = true;
      this._glow.visible = false;
      this._totalWinPanel.scale.set(0, 0);

      this._textAnimTimeline = gsap.timeline();

      this._textAnimTimeline.fromTo(
        self._totalWinPanel.scale,
        {
          x: 0,
          y: 0,
        },
        {
          duration: scaleInTime,
          ease: 'linear',
          x: 0.3,
          y: 0.3,
        }
      );
      this._textAnimTimeline.to(self._totalWinPanel, {
        duration: duration,
      });
      this._textAnimTimeline.to(self._totalWinPanel.scale, {
        duration: scaleOutTime,
        ease: 'linear',
        x: 0,
        y: 0,
      });
    };

    setText = function (value, ignoreMultiplier = false) {
      this._value = value;
      if (!ignoreMultiplier) {
        value /= gameController.currentMultiplier;
      }
      var valueText = gdk.formatCurrency(value);
      this._totalWinText.setText(valueText);
      this._multiplierText.setText(`X${gameController.currentMultiplier}`);
      this.position = helpers.getSymbolPos(2, 1);
    };

    animate = function (introOnly, cyclingWins, inShuffle) {
      const thisMultiplier = gameController.currentMultiplier;
      this._multiplierText.visible = false;
      this._totalWinBacker.visible = false;
      this._glow.alpha = 1;
      this._glow.visible = true;
      this._glowTween.play();
      this.position = helpers.getSymbolPos(2, 1);
      let self = this;
      let scale = 0.7;
      if (cyclingWins) {
        scale = 0.6;
      }

      const stake = resourceManager.getController('stakeController').BaseStake;
      if (this._value > 5 * stake) {
        soundManager.play('win_prize_amount_hi');
      } else if (this._value > 3 * stake) {
        soundManager.play('win_prize_amount_med');
      } else if (this._value > stake) {
        soundManager.play('win_prize_amount');
      }

      this._multiplierTimeline = gsap.timeline();

      this._textAnimTimeline = gsap.timeline();
      // SCALE IN
      this._textAnimTimeline.fromTo(
        self._totalWinPanel.scale,
        {
          x: 0,
          y: 0,
        },
        {
          duration: 1,
          ease: 'back.out(1)',
          x: scale,
          y: scale,
          onUpdate: () => {
            this.position = helpers.getSymbolPos(2, 1);
          },
          onComplete: () => {
            if (inShuffle) {
              if (thisMultiplier <= 1) {
                self.animateOut();
                return;
              }
            }
            if (!introOnly && !inShuffle) {
              self.animateOut();
              return;
            }
            if (thisMultiplier > 1) {
              // ANIMATE MULTIPLIER SCALE IN
              this._multiplierText.position.y = 100;
              this._multiplierText.scale.set(0, 0);
              this._multiplierText.visible = true;
              this._multiplierTimeline.fromTo(
                self._multiplierText,
                {
                  pixi: {
                    scaleX: 0,
                    scaleY: 0,
                  },
                },
                {
                  duration: 1,
                  ease: 'back.out(1)',
                  pixi: {
                    scaleX: scale,
                    scaleY: scale,
                  },
                  onUpdate: () => {
                    this.position = helpers.getSymbolPos(2, 1);
                  },
                }
              );
            }
          },
        }
      );
      if (inShuffle && thisMultiplier > 1) {
        // MOVE UP MAKING ROOM FOR MULTIPLIER
        this._textAnimTimeline.to(self._totalWinPanel, {
          duration: 1,
          ease: 'linear',
          onComplete: () => {
            soundManager.play('multiplierApply');
            self._winTextSparks.visible = true;
            self._winTextSparks.gotoAndPlay(0);
            this._multiplierTimeline.to(self._multiplierText, {
              duration: 0.25,
              ease: 'linear',
              y: self._multiplierText.position.y - 100,
              alpha: 0,
              onComplete: () => {
                self._multiplierText.scale = 0;
                self._multiplierText.position.y = 0;
                self._multiplierText.alpha = 1;
                self._multiplierText.visible = false;
                self._winTextSparks.visible = false;

                this._multiplierTimeline.to(self._totalWinPanel.scale, {
                  duration: 0.2,
                  ease: 'power1.inOut',
                  x: 1.1,
                  y: 1.1,
                  yoyo: true,
                  repeat: 2,
                  onComplete: () => {
                    self._totalWinPanel.scale.set(1, 1);
                  },
                });
              },
            });
          },
        });
        // MOVE BACK DOWN
        this._textAnimTimeline.to(self._totalWinPanel, {
          duration: 1,
          ease: 'back.out(1)',
          y: self._totalWinPanel.position.y,
          onUpdate: () => {
            self._totalWinText.setText(gdk.formatCurrency(this._value));
          },
          onComplete: () => {
            if (!introOnly) {
              self.animateOut();
            }
          },
        });
      }
    };

    animateOut = function () {
      this.position = helpers.getSymbolPos(2, 1);
      let self = this;

      let winningsMeterPos = {
        x: gameController.winningsContainer.position.x,
        y: gameController.winningsContainer.position.y,
      };

      this._animOut = gsap.timeline();

      this._animOut.to(
        self._totalWinPanel.scale,
        {
          duration: 0.4,
          ease: 'power1.inOut',
          x: 0,
          y: 0,
        },
        0
      );

      this._animOut.to(
        self._glow,
        {
          duration: 0.1,
          ease: 'linear',
          alpha: 0,
        },
        0
      );

      this._animOut.to(
        this.position,
        {
          duration: 0.4,
          ease: 'power1.inOut',
          x: winningsMeterPos.x,
          y: winningsMeterPos.y,
          onComplete: () => {
            soundManager.play('win_meter_countup_loop');
            gameData.winningsMeter.countUp(this._value, 500, () => {
              soundManager.stop('win_meter_countup_loop');
              soundManager.play('win_meter_countup_loop_end');
            });
            this._glow.visible = false;
            this._glow.alpha = 0;
            this._glowTween.pause(0);
            this._animOut = undefined;
          },
        },
        0
      );
    };

    cycleAnimate = function () {
      let self = this;

      gsap.fromTo(
        self.scale,
        {
          x: 0,
          y: 0,
        },
        {
          duration: 1,
          ease: 'back.out(2)',
          x: 2,
          y: 2,
        }
      );
    };

    skip = function () {
      this._textAnimTimeline?.progress(1);
      this.show(false);
      gameData.winningsMeter.set(gameController.totalWinnings);
    };

    show = function (show, value) {
      this._container.visible = show;

      if (value) this.setText(value);
    };

    setScale = function (scale) {
      this._container.scale.set(scale);
    };

    countUpWin(winValue, time, startDelay) {
      let obj = {
        val: this._value,
      };

      this._totalWinPanel.scale.set(0.3, 0.3);

      gsap.to(obj, {
        delay: startDelay,
        duration: time,
        ease: 'linear',
        val: winValue,
        onUpdate: () => {
          let valueText = gdk.formatCurrency(obj.val);
          this._totalWinText.setText(valueText);
          this._totalWinPanel.scale.set(0.3, 0.3);
        },
        onComplete: () => {
          let valueText = gdk.formatCurrency(winValue);
          this._totalWinText.setText(valueText);
          this._totalWinPanel.scale.set(0.3, 0.3);
        },
      });
    }

    doSpin() {
      if (this._animOut) {
        this._animOut.kill();
        this._animOut = undefined;

        this._glow.visible = false;
        this._glow.alpha = 0;
        this._glowTween.pause(0);
      }
      gameData.winningsMeter.cancelCountUp();
      timerManager.addTimeout(500, () => {
        gameData.winningsMeter.set(0);
      });
    }
  }

  let winningsTextCreator = function (json) {
    return new WinningsText();
  };

  resourceManager.registerObjectType(
    'winningsText',
    winningsTextCreator,
    function () {},
    function () {
      return [];
    }
  );
})();
